import { FunctionComponent } from 'react';
import { SearchTag } from '../SearchTag';

import { SelectOption, NamedSelectOption } from '../Common/Select/sharedTypes';

type SearchTagType = SelectOption & {
    isActive?: boolean;
};

import styles from './main.scss';

type SearchTagsProps = {
    disabled?: boolean;
    onDelete: (option: NamedSelectOption) => void;
    name: string;
    tags: SearchTagType[];
    tagSpacing?: 'xSmall' | 'none';
};

export const SearchTags: FunctionComponent<SearchTagsProps> = props => {
    const { disabled, onDelete, name, tags, tagSpacing } = props;
    return (
        <div data-tn={name} className={styles.searchTagsWrapper}>
            {tags.map(({ label, value, isActive }: SearchTagType) => {
                const key = `${name}-${value}`;
                const searchTagProps = {
                    isActive: !disabled && isActive,
                    disabled,
                    onDelete: () => onDelete({ value, label, name }),
                    key,
                    label,
                    dataTn: key,
                    tagSpacing,
                };
                return <SearchTag {...searchTagProps}>{label}</SearchTag>;
            })}
        </div>
    );
};
